// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

import { validate } from './modules/_validate.mjs';
import { navigationSlider } from "./modules/_carousels.mjs";
import { stappenSlider } from "./modules/_carousels.mjs";

// Make Fancybox globally available
window.Fancybox = Fancybox;

document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    navigationSlider();
    stappenSlider();
});
